import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import SearchIcon from '@material-ui/icons/Search';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Autocomplete,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  TextField
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Controls from '../controls/Controls';
import { useInvoiceContext } from '../../context/invoice_context';
import { useConstantsContext } from '../../context/constants_context';
import { useProductContext } from '../../context/product_context';
import { baseUrl } from '../../utils/constants';
import InvoiceDetails from './InvoiceDetails';

export default function CreateInvoice() {
  const { addToInvoice } = useInvoiceContext();
  const { setClients } = useConstantsContext();
  const { productList } = useProductContext();
  const [showList, setShowList] = useState(false);
  const [noOfRecords, setNoOfRecords] = useState(-1);
  const navigate = useNavigate();

  const PersonalDetailsSchema = Yup.object().shape({
    units: Yup.number(),
    sellingPrice: Yup.number(),
    total: Yup.number()
  });

  const formik = useFormik({
    initialValues: {
      productID: 0,
      productName: '',
      productSelect: '',
      units: 1,
      sellingPrice: 0,
      total: 0
    },
    enableReinitialize: true,
    validationSchema: PersonalDetailsSchema,
    onSubmit: (values) => {
      setShowList(false);
      console.log('search fields', values);
      handleAddToInvoice(values);
    }
  });

  const handleProductChange = (e) => {
    formik.setFieldValue('sellingPrice', e.sellingPrice.toFixed(2));
    formik.setFieldValue('total', (e.sellingPrice * formik.values.units).toFixed(2));
    formik.setFieldValue('productID', e.productID);
    formik.setFieldValue('productName', e.productName);
  };

  const handleAddToInvoice = (e) => {
    console.log('currentInvoice', e);
    const parsedSellingPrice = parseFloat(e.sellingPrice, 10);
    const parsedTotal = parseFloat(e.total, 10);
    // addToInvoice(e.productID, e.productName, e.units, parsedSellingPrice, parsedTotal);
  };

  return (
    <>
      <Card>
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Typography component="span" variant="h6" gutterBottom>
                Product Search
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    options={productList}
                    getOptionLabel={(option) =>
                      option.productName || 'ABDNOMINAL CORSET PLAIN (XX)'
                    }
                    value={formik.values.productID}
                    isOptionEqualToValue={(option, value) => option.productID === value.productID}
                    size="small"
                    fullWidth
                    onChange={(e, value) => {
                      console.log('e here', e);
                      console.log('value e here', value);
                      // formik.setFieldValue('productSelect', value.productName);
                      handleProductChange(value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        label="Product Name"
                        placeholder="Select Product"
                        variant="outlined"
                        size="small"
                        {...params}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={1.5}>
                  <Controls.InputNumber name="units" label="Units" />
                </Grid>
                <Grid item xs={12} sm={1.5}>
                  <Controls.InputNumber name="sellingPrice" label="Price" />
                </Grid>
                <Grid item xs={12} sm={1.5}>
                  <Controls.InputNumber name="total" label="Total" />
                </Grid>
                <Grid item xs={12} sm={1.5}>
                  <Button
                    type="submit"
                    variant="outlined"
                    startIcon={<AddCircleOutlineIcon />}
                    // onClick={() => handleAddToInvoice()}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </CardContent>
      </Card>
      <InvoiceDetails />
    </>
  );
}
